import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import TextCell from "./core/TextCell.js";

const AttributeNameAdminCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const editableAttribute = !!(props as any).openEditAttribute;

  return (
    <TableCell
      triggerButtonProps={
        editableAttribute
          ? {
              onPress: () => (props as any).openEditAttribute(props.data),
              label: "Edit Attribute",
              icon: "edit",
              e2eActionId: "edit-attribute",
            }
          : undefined
      }
    >
      <TextCell {...props} tooltip={props.value} />
    </TableCell>
  );
};

export { AttributeNameAdminCell };
export default AttributeNameAdminCell;
